/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable camelcase */

const EMPTY_OBJECT = Object.create(null);
export class Messages {
  constructor(translator) {
    this.translator = translator;
  }
  _translate(key, params) {
    return this.translator.translate(key, params);
  }
  _translateWithChildren(key, params, children) {
    return this.translator.translateWithChildren(key, params, children);
  }
  ASA_PRODUCT_NAME() {
    return this._translate('ASA_PRODUCT_NAME', EMPTY_OBJECT);
  }
  ASA_PAGE_ACTIONS_CHAT_WITH_ASSISTANT_CTA(name) {
    return this._translate('ASA_PAGE_ACTIONS_CHAT_WITH_ASSISTANT_CTA', {
      name
    });
  }
  ASA_PAGE_ACTIONS_CHAT_SHAREABLE_LINK_MODAL_CTA() {
    return this._translate('ASA_PAGE_ACTIONS_CHAT_SHAREABLE_LINK_MODAL_CTA', EMPTY_OBJECT);
  }
  ASA_PAGE_ACTIONS_SIMULATE_CHAT_CTA() {
    return this._translate('ASA_PAGE_ACTIONS_SIMULATE_CHAT_CTA', EMPTY_OBJECT);
  }
  ASA_PAGE_ACTIONS_SCHEDULING_PREFERENCES_CTA() {
    return this._translate('ASA_PAGE_ACTIONS_SCHEDULING_PREFERENCES_CTA', EMPTY_OBJECT);
  }
  ASA_PAGE_ACTIONS_MANAGE_MENU_CTA() {
    return this._translate('ASA_PAGE_ACTIONS_MANAGE_MENU_CTA', EMPTY_OBJECT);
  }
  ASA_PAGE_ACTIONS_MANAGE_MENU_SHARE_SCHEDULING_LINK_CTA() {
    return this._translate('ASA_PAGE_ACTIONS_MANAGE_MENU_SHARE_SCHEDULING_LINK_CTA', EMPTY_OBJECT);
  }
  ASA_PAGE_ACTIONS_MANAGE_MENU_SIMULATE_CHAT_CTA() {
    return this._translate('ASA_PAGE_ACTIONS_MANAGE_MENU_SIMULATE_CHAT_CTA', EMPTY_OBJECT);
  }
  ASA_PAGE_ACTIONS_MANAGE_MENU_GIVE_FEEDBACK_CTA() {
    return this._translate('ASA_PAGE_ACTIONS_MANAGE_MENU_GIVE_FEEDBACK_CTA', EMPTY_OBJECT);
  }
  ASA_PAGE_ACTIONS_MANAGE_MENU_LEARN_MORE_CTA() {
    return this._translate('ASA_PAGE_ACTIONS_MANAGE_MENU_LEARN_MORE_CTA', EMPTY_OBJECT);
  }
  ASA_PAGE_ACTIONS_MANAGE_MENU_LEARN_MORE_KB_LINK() {
    return this._translate('ASA_PAGE_ACTIONS_MANAGE_MENU_LEARN_MORE_KB_LINK', EMPTY_OBJECT);
  }
  ASA_DATE_UTIL_DAYS_FROM_NOW(count) {
    return this._translate('ASA_DATE_UTIL_DAYS_FROM_NOW', {
      count
    });
  }
  ASA_DATE_UTIL_TOMORROW() {
    return this._translate('ASA_DATE_UTIL_TOMORROW', EMPTY_OBJECT);
  }
  ASA_DATE_UTIL_TODAY() {
    return this._translate('ASA_DATE_UTIL_TODAY', EMPTY_OBJECT);
  }
  ASA_WELCOME_BUTTON_TEXT() {
    return this._translate('ASA_WELCOME_BUTTON_TEXT', EMPTY_OBJECT);
  }
  ASA_GET_STARTED_ASSISTANT_INTRO_TITLE() {
    return this._translate('ASA_GET_STARTED_ASSISTANT_INTRO_TITLE', EMPTY_OBJECT);
  }
  ASA_GET_STARTED_ASSISTANT_INTRO_SUBTITLE() {
    return this._translate('ASA_GET_STARTED_ASSISTANT_INTRO_SUBTITLE', EMPTY_OBJECT);
  }
  ASA_GET_STARTED_ASSISTANT_INTRO_LIST_TITLE() {
    return this._translate('ASA_GET_STARTED_ASSISTANT_INTRO_LIST_TITLE', EMPTY_OBJECT);
  }
  ASA_GET_STARTED_ASSISTANT_INTRO_LIST_ITEM1() {
    return this._translate('ASA_GET_STARTED_ASSISTANT_INTRO_LIST_ITEM1', EMPTY_OBJECT);
  }
  ASA_GET_STARTED_ASSISTANT_INTRO_LIST_ITEM2() {
    return this._translate('ASA_GET_STARTED_ASSISTANT_INTRO_LIST_ITEM2', EMPTY_OBJECT);
  }
  ASA_GET_STARTED_ASSISTANT_INTRO_LIST_ITEM3() {
    return this._translate('ASA_GET_STARTED_ASSISTANT_INTRO_LIST_ITEM3', EMPTY_OBJECT);
  }
  ASA_GET_STARTED_ASSISTANT_INTRO_FOOTER() {
    return this._translate('ASA_GET_STARTED_ASSISTANT_INTRO_FOOTER', EMPTY_OBJECT);
  }
  ASA_GET_STARTED_ASSISTANT_INTRO_FOMO_FOOTER() {
    return this._translate('ASA_GET_STARTED_ASSISTANT_INTRO_FOMO_FOOTER', EMPTY_OBJECT);
  }
  ASA_GET_STARTED_ASSISTANT_INTRO_CTA() {
    return this._translate('ASA_GET_STARTED_ASSISTANT_INTRO_CTA', EMPTY_OBJECT);
  }
  ASA_GET_STARTED_ASSISTANT_INTRO_FOMO_CTA() {
    return this._translate('ASA_GET_STARTED_ASSISTANT_INTRO_FOMO_CTA', EMPTY_OBJECT);
  }
  ASA_OPEN_CHAT_FIRST_USER_MESSAGE() {
    return this._translate('ASA_OPEN_CHAT_FIRST_USER_MESSAGE', EMPTY_OBJECT);
  }
  ASA_OPEN_CHAT_NEW_RECURRING_SCHEDULE_FIRST_USER_MESSAGE() {
    return this._translate('ASA_OPEN_CHAT_NEW_RECURRING_SCHEDULE_FIRST_USER_MESSAGE', EMPTY_OBJECT);
  }
  ASA_OPEN_CHAT_NEW_TASK_FIRST_USER_MESSAGE() {
    return this._translate('ASA_OPEN_CHAT_NEW_TASK_FIRST_USER_MESSAGE', EMPTY_OBJECT);
  }
  ASA_OPEN_CHAT_TASK_IN_PROGRESS_FIRST_USER_MESSAGE(taskDescription) {
    return this._translate('ASA_OPEN_CHAT_TASK_IN_PROGRESS_FIRST_USER_MESSAGE', {
      taskDescription
    });
  }
  ASA_OPEN_CHAT_TASK_ACTION_NEEDED_FIRST_USER_MESSAGE(taskDescription) {
    return this._translate('ASA_OPEN_CHAT_TASK_ACTION_NEEDED_FIRST_USER_MESSAGE', {
      taskDescription
    });
  }
  ASA_OPEN_CHAT_TASK_AWAITING_DETAILS_FIRST_USER_MESSAGE(taskDescription) {
    return this._translate('ASA_OPEN_CHAT_TASK_AWAITING_DETAILS_FIRST_USER_MESSAGE', {
      taskDescription
    });
  }
  ASA_OPEN_CHAT_TASK_PENDING_APPROVAL_FIRST_USER_MESSAGE(taskDescription) {
    return this._translate('ASA_OPEN_CHAT_TASK_PENDING_APPROVAL_FIRST_USER_MESSAGE', {
      taskDescription
    });
  }
  ASA_OPEN_CHAT_TASK_DEFAULT_FIRST_USER_MESSAGE(taskDescription) {
    return this._translate('ASA_OPEN_CHAT_TASK_DEFAULT_FIRST_USER_MESSAGE', {
      taskDescription
    });
  }
  ASA_PERSONA_SETUP_PAGE_TITLE() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_TITLE', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_SUBTITLE() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_SUBTITLE', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_SIMULATE_CHAT_LABEL() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_SIMULATE_CHAT_LABEL', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_PERSONA_SETTINGS_ACCORDION() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_PERSONA_SETTINGS_ACCORDION', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_PERSONA_SETTINGS_ACCORDION_SUBTITLE() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_PERSONA_SETTINGS_ACCORDION_SUBTITLE', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_ACCORDION() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_ACCORDION', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_ACCORDION_SUBTITLE() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_ACCORDION_SUBTITLE', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_CLIENT_CONTACT_ACCORDION() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_CLIENT_CONTACT_ACCORDION', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_CLIENT_CONTACT_ACCORDION_SUBTITLE() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_CLIENT_CONTACT_ACCORDION_SUBTITLE', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_SAVE_CTA() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_SAVE_CTA', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_DISCARD_CTA() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_DISCARD_CTA', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_ASSISTANT_NAME_LABEL() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_ASSISTANT_NAME_LABEL', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_ASSISTANT_NAME_PLACEHOLDER() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_ASSISTANT_NAME_PLACEHOLDER', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_PERSONALITY_LABEL() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_PERSONALITY_LABEL', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_PERSONALITY_RESET_CTA() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_PERSONALITY_RESET_CTA', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_PERSONALITY_GENERATE_TITLE() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_PERSONALITY_GENERATE_TITLE', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_PERSONALITY_GENERATE_RESET_CTA() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_PERSONALITY_GENERATE_RESET_CTA', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_PERSONALITY_GENERATE_PLACEHOLDER() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_PERSONALITY_GENERATE_PLACEHOLDER', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_PERSONALITY_GENERATE_BACK_CTA() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_PERSONALITY_GENERATE_BACK_CTA', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_PERSONALITY_GENERATE_CTA() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_PERSONALITY_GENERATE_CTA', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_RECURRING_TITLE() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_RECURRING_TITLE', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_AUTO_RECURRING_TITLE() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_AUTO_RECURRING_TITLE', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_AUTO_RECURRING_SUBTITLE(name) {
    return this._translate('ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_AUTO_RECURRING_SUBTITLE', {
      name
    });
  }
  ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_CUSTOM_RECURRING_TITLE() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_CUSTOM_RECURRING_TITLE', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_CUSTOM_RECURRING_SUBTITLE() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_CUSTOM_RECURRING_SUBTITLE', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_REMINDERS_TITLE() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_REMINDERS_TITLE', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_REMINDERS_LABEL() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_REMINDERS_LABEL', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_WAITLIST_TITLE() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_WAITLIST_TITLE', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_WAITLIST_LABEL(name) {
    return this._translate('ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_WAITLIST_LABEL', {
      name
    });
  }
  ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_WAITLIST_LINK_TEXT() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_WAITLIST_LINK_TEXT', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_WAITLIST_LEARN_MORE_KB_LINK() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_COMMUNICATION_OPTIONS_WAITLIST_LEARN_MORE_KB_LINK', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_CLIENT_CONTACT_SETTINGS_TITLE(name) {
    return this._translate('ASA_PERSONA_SETUP_PAGE_CLIENT_CONTACT_SETTINGS_TITLE', {
      name
    });
  }
  ASA_PERSONA_SETUP_PAGE_CLIENT_CONTACT_SETTINGS_SUBTITLE(name) {
    return this._translate('ASA_PERSONA_SETUP_PAGE_CLIENT_CONTACT_SETTINGS_SUBTITLE', {
      name
    });
  }
  ASA_PERSONA_SETUP_PAGE_SPECIAL_GUIDANCE_TITLE() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_SPECIAL_GUIDANCE_TITLE', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_SPECIAL_GUIDANCE_TITLE_TOOLTIP() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_SPECIAL_GUIDANCE_TITLE_TOOLTIP', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_SPECIAL_GUIDANCE_ADD_ENHANCEMENT_CTA() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_SPECIAL_GUIDANCE_ADD_ENHANCEMENT_CTA', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_SPECIAL_GUIDANCE_ITEM_TITLE_LABEL() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_SPECIAL_GUIDANCE_ITEM_TITLE_LABEL', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_SPECIAL_GUIDANCE_ITEM_TITLE_PLACEHOLDER() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_SPECIAL_GUIDANCE_ITEM_TITLE_PLACEHOLDER', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_SPECIAL_GUIDANCE_ITEM_DESCRIPTION_LABEL() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_SPECIAL_GUIDANCE_ITEM_DESCRIPTION_LABEL', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_SPECIAL_GUIDANCE_ITEM_DESCRIPTION_PLACEHOLDER() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_SPECIAL_GUIDANCE_ITEM_DESCRIPTION_PLACEHOLDER', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_SPECIAL_GUIDANCE_ITEM_CLEAR_CTA() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_SPECIAL_GUIDANCE_ITEM_CLEAR_CTA', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_SPECIAL_GUIDANCE_ITEM_DELETE_CTA() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_SPECIAL_GUIDANCE_ITEM_DELETE_CTA', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_PRONOUN_SELECT_LABEL() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_PRONOUN_SELECT_LABEL', EMPTY_OBJECT);
  }
  ASA_PERSONA_SETUP_PAGE_PRONOUN_SELECT_TOOLTIP() {
    return this._translate('ASA_PERSONA_SETUP_PAGE_PRONOUN_SELECT_TOOLTIP', EMPTY_OBJECT);
  }
  ASA_PERSONA_SIMULATION_MODAL_HEADER() {
    return this._translate('ASA_PERSONA_SIMULATION_MODAL_HEADER', EMPTY_OBJECT);
  }
  ASA_PERSONA_SIMULATION_MODAL_TITLE(name) {
    return this._translate('ASA_PERSONA_SIMULATION_MODAL_TITLE', {
      name
    });
  }
  ASA_PERSONA_SIMULATION_MODAL_SUBTITLE(name, pronouns) {
    return this._translate('ASA_PERSONA_SIMULATION_MODAL_SUBTITLE', {
      name,
      pronouns
    });
  }
  ASA_PERSONA_SIMULATION_MODAL_CONTENT(possessive) {
    return this._translate('ASA_PERSONA_SIMULATION_MODAL_CONTENT', {
      possessive
    });
  }
  ASA_PERSONA_SIMULATION_MODAL_CTA() {
    return this._translate('ASA_PERSONA_SIMULATION_MODAL_CTA', EMPTY_OBJECT);
  }
  ASA_PERSONA_SIMULATION_MODAL_FOOTER() {
    return this._translate('ASA_PERSONA_SIMULATION_MODAL_FOOTER', EMPTY_OBJECT);
  }
  ASA_PERSONA_SIMULATION_MODAL_FOOTER_CTA() {
    return this._translate('ASA_PERSONA_SIMULATION_MODAL_FOOTER_CTA', EMPTY_OBJECT);
  }
  ASA_NO_CALENDAR_CONNECTED_MODAL_TITLE() {
    return this._translate('ASA_NO_CALENDAR_CONNECTED_MODAL_TITLE', EMPTY_OBJECT);
  }
  ASA_NO_CALENDAR_CONNECTED_MODAL_PRIMARY_CTA() {
    return this._translate('ASA_NO_CALENDAR_CONNECTED_MODAL_PRIMARY_CTA', EMPTY_OBJECT);
  }
  ASA_NO_CALENDAR_CONNECTED_MODAL_SECONDARY_CTA() {
    return this._translate('ASA_NO_CALENDAR_CONNECTED_MODAL_SECONDARY_CTA', EMPTY_OBJECT);
  }
  ASA_PERSONA_SIMULATION_MODAL_NO_CALENDAR_CONTENT() {
    return this._translate('ASA_PERSONA_SIMULATION_MODAL_NO_CALENDAR_CONTENT', EMPTY_OBJECT);
  }
  ASA_IDENTITY_TYPE_USER_NO_BUSINESS_NAME() {
    return this._translate('ASA_IDENTITY_TYPE_USER_NO_BUSINESS_NAME', EMPTY_OBJECT);
  }
  ASA_IDENTITY_TYPE_USER(businessName) {
    return this._translate('ASA_IDENTITY_TYPE_USER', {
      businessName
    });
  }
  ASA_IDENTITY_TYPE_ASSISTANT() {
    return this._translate('ASA_IDENTITY_TYPE_ASSISTANT', EMPTY_OBJECT);
  }
  ASA_IDENTITY_TYPE_CONTACT() {
    return this._translate('ASA_IDENTITY_TYPE_CONTACT', EMPTY_OBJECT);
  }
  ASA_PRONOUN_HE() {
    return this._translate('ASA_PRONOUN_HE', EMPTY_OBJECT);
  }
  ASA_PRONOUN_HE_SUBJECTIVE() {
    return this._translate('ASA_PRONOUN_HE_SUBJECTIVE', EMPTY_OBJECT);
  }
  ASA_PRONOUN_HE_OBJECTIVE() {
    return this._translate('ASA_PRONOUN_HE_OBJECTIVE', EMPTY_OBJECT);
  }
  ASA_PRONOUN_HE_POSSESSIVE() {
    return this._translate('ASA_PRONOUN_HE_POSSESSIVE', EMPTY_OBJECT);
  }
  ASA_PRONOUN_SHE() {
    return this._translate('ASA_PRONOUN_SHE', EMPTY_OBJECT);
  }
  ASA_PRONOUN_SHE_SUBJECTIVE() {
    return this._translate('ASA_PRONOUN_SHE_SUBJECTIVE', EMPTY_OBJECT);
  }
  ASA_PRONOUN_SHE_OBJECTIVE() {
    return this._translate('ASA_PRONOUN_SHE_OBJECTIVE', EMPTY_OBJECT);
  }
  ASA_PRONOUN_SHE_POSSESSIVE() {
    return this._translate('ASA_PRONOUN_SHE_POSSESSIVE', EMPTY_OBJECT);
  }
  ASA_PRONOUN_THEY() {
    return this._translate('ASA_PRONOUN_THEY', EMPTY_OBJECT);
  }
  ASA_PRONOUN_THEY_SUBJECTIVE() {
    return this._translate('ASA_PRONOUN_THEY_SUBJECTIVE', EMPTY_OBJECT);
  }
  ASA_PRONOUN_THEY_OBJECTIVE() {
    return this._translate('ASA_PRONOUN_THEY_OBJECTIVE', EMPTY_OBJECT);
  }
  ASA_PRONOUN_THEY_POSSESSIVE() {
    return this._translate('ASA_PRONOUN_THEY_POSSESSIVE', EMPTY_OBJECT);
  }
  ASA_PRONOUN_OTHER() {
    return this._translate('ASA_PRONOUN_OTHER', EMPTY_OBJECT);
  }
  ASA_PRONOUN_OTHER_SUBJECTIVE() {
    return this._translate('ASA_PRONOUN_OTHER_SUBJECTIVE', EMPTY_OBJECT);
  }
  ASA_PRONOUN_OTHER_OBJECTIVE() {
    return this._translate('ASA_PRONOUN_OTHER_OBJECTIVE', EMPTY_OBJECT);
  }
  ASA_PRONOUN_OTHER_POSSESSIVE() {
    return this._translate('ASA_PRONOUN_OTHER_POSSESSIVE', EMPTY_OBJECT);
  }
  ASA_AVAILABILITY_HOURS_PICKER_START_TIME() {
    return this._translate('ASA_AVAILABILITY_HOURS_PICKER_START_TIME', EMPTY_OBJECT);
  }
  ASA_AVAILABILITY_HOURS_PICKER_END_TIME() {
    return this._translate('ASA_AVAILABILITY_HOURS_PICKER_END_TIME', EMPTY_OBJECT);
  }
  ASA_AVAILABILITY_HOURS_PICKER_DAYS() {
    return this._translate('ASA_AVAILABILITY_HOURS_PICKER_DAYS', EMPTY_OBJECT);
  }
  ASA_AVAILABILITY_HOURS_PICKER_ADD() {
    return this._translate('ASA_AVAILABILITY_HOURS_PICKER_ADD', EMPTY_OBJECT);
  }
  ASA_DAY_OF_WEEK_MONDAY() {
    return this._translate('ASA_DAY_OF_WEEK_MONDAY', EMPTY_OBJECT);
  }
  ASA_DAY_OF_WEEK_TUESDAY() {
    return this._translate('ASA_DAY_OF_WEEK_TUESDAY', EMPTY_OBJECT);
  }
  ASA_DAY_OF_WEEK_WEDNESDAY() {
    return this._translate('ASA_DAY_OF_WEEK_WEDNESDAY', EMPTY_OBJECT);
  }
  ASA_DAY_OF_WEEK_THURSDAY() {
    return this._translate('ASA_DAY_OF_WEEK_THURSDAY', EMPTY_OBJECT);
  }
  ASA_DAY_OF_WEEK_FRIDAY() {
    return this._translate('ASA_DAY_OF_WEEK_FRIDAY', EMPTY_OBJECT);
  }
  ASA_DAY_OF_WEEK_SATURDAY() {
    return this._translate('ASA_DAY_OF_WEEK_SATURDAY', EMPTY_OBJECT);
  }
  ASA_DAY_OF_WEEK_SUNDAY() {
    return this._translate('ASA_DAY_OF_WEEK_SUNDAY', EMPTY_OBJECT);
  }
  ASA_TRAIT_FRIENDLY() {
    return this._translate('ASA_TRAIT_FRIENDLY', EMPTY_OBJECT);
  }
  ASA_TRAIT_PROFESSIONAL() {
    return this._translate('ASA_TRAIT_PROFESSIONAL', EMPTY_OBJECT);
  }
  ASA_TRAIT_WARM() {
    return this._translate('ASA_TRAIT_WARM', EMPTY_OBJECT);
  }
  ASA_TRAIT_POLITE() {
    return this._translate('ASA_TRAIT_POLITE', EMPTY_OBJECT);
  }
  ASA_TRAIT_SUPPORTIVE() {
    return this._translate('ASA_TRAIT_SUPPORTIVE', EMPTY_OBJECT);
  }
  ASA_TRAIT_CONFIDENT() {
    return this._translate('ASA_TRAIT_CONFIDENT', EMPTY_OBJECT);
  }
  ASA_TRAIT_CONCISE() {
    return this._translate('ASA_TRAIT_CONCISE', EMPTY_OBJECT);
  }
  ASA_TRAIT_CHATTY() {
    return this._translate('ASA_TRAIT_CHATTY', EMPTY_OBJECT);
  }
  ASA_TRAIT_CALM() {
    return this._translate('ASA_TRAIT_CALM', EMPTY_OBJECT);
  }
  ASA_TRAIT_CHEERFUL() {
    return this._translate('ASA_TRAIT_CHEERFUL', EMPTY_OBJECT);
  }
  ASA_TRAIT_PLAYFUL() {
    return this._translate('ASA_TRAIT_PLAYFUL', EMPTY_OBJECT);
  }
  ASA_TRAIT_FORMAL() {
    return this._translate('ASA_TRAIT_FORMAL', EMPTY_OBJECT);
  }
  ASA_TRAIT_RESOURCEFUL() {
    return this._translate('ASA_TRAIT_RESOURCEFUL', EMPTY_OBJECT);
  }
  ASA_TRAIT_CASUAL() {
    return this._translate('ASA_TRAIT_CASUAL', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_TITLE() {
    return this._translate('ASA_TASKS_PAGE_TITLE', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_SUBTITLE(name) {
    return this._translate('ASA_TASKS_PAGE_SUBTITLE', {
      name
    });
  }
  ASA_TASKS_PAGE_TABLE_TITLE(name) {
    return this._translate('ASA_TASKS_PAGE_TABLE_TITLE', {
      name
    });
  }
  ASA_TASKS_PAGE_TAB_ALL() {
    return this._translate('ASA_TASKS_PAGE_TAB_ALL', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_TAB_RECOMMENDATIONS() {
    return this._translate('ASA_TASKS_PAGE_TAB_RECOMMENDATIONS', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_TAB_OPEN() {
    return this._translate('ASA_TASKS_PAGE_TAB_OPEN', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_TAB_COMPLETED() {
    return this._translate('ASA_TASKS_PAGE_TAB_COMPLETED', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_TAB_FAILED() {
    return this._translate('ASA_TASKS_PAGE_TAB_FAILED', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_TAB_ACTION_NEEDED() {
    return this._translate('ASA_TASKS_PAGE_TAB_ACTION_NEEDED', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_STATUS_COLUMN_TITLE() {
    return this._translate('ASA_TASKS_PAGE_STATUS_COLUMN_TITLE', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_CREATE_DATE_COLUMN_TITLE() {
    return this._translate('ASA_TASKS_PAGE_CREATE_DATE_COLUMN_TITLE', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_CONTACT_COLUMN_TITLE() {
    return this._translate('ASA_TASKS_PAGE_CONTACT_COLUMN_TITLE', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_SERVICE_COLUMN_TITLE() {
    return this._translate('ASA_TASKS_PAGE_SERVICE_COLUMN_TITLE', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_CALENDAR_COLUMN_TITLE() {
    return this._translate('ASA_TASKS_PAGE_CALENDAR_COLUMN_TITLE', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_INSIGHTS_CLIENTS_INTERACTED(name) {
    return this._translate('ASA_TASKS_PAGE_INSIGHTS_CLIENTS_INTERACTED', {
      name
    });
  }
  ASA_TASKS_PAGE_INSIGHTS_CLIENTS_INTERACTED_CTA(name) {
    return this._translate('ASA_TASKS_PAGE_INSIGHTS_CLIENTS_INTERACTED_CTA', {
      name
    });
  }
  ASA_TASKS_PAGE_INSIGHTS_RECOMMENDATIONS(name) {
    return this._translate('ASA_TASKS_PAGE_INSIGHTS_RECOMMENDATIONS', {
      name
    });
  }
  ASA_TASKS_PAGE_INSIGHTS_RECOMMENDATIONS_CTA(name) {
    return this._translate('ASA_TASKS_PAGE_INSIGHTS_RECOMMENDATIONS_CTA', {
      name
    });
  }
  ASA_TASKS_PAGE_INSIGHTS_CLIENTS_INTERACTED_VIA_LINK() {
    return this._translate('ASA_TASKS_PAGE_INSIGHTS_CLIENTS_INTERACTED_VIA_LINK', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_INSIGHTS_CLIENTS_INTERACTED_VIA_LINK_CTA(name) {
    return this._translate('ASA_TASKS_PAGE_INSIGHTS_CLIENTS_INTERACTED_VIA_LINK_CTA', {
      name
    });
  }
  ASA_TASKS_PAGE_INSIGHTS_SCHEDULING_INSIGHTS(name) {
    return this._translate('ASA_TASKS_PAGE_INSIGHTS_SCHEDULING_INSIGHTS', {
      name
    });
  }
  ASA_TASKS_PAGE_INSIGHTS_SCHEDULING_INSIGHTS_CTA() {
    return this._translate('ASA_TASKS_PAGE_INSIGHTS_SCHEDULING_INSIGHTS_CTA', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_SETUP_WIDGET_STAT_TITLE() {
    return this._translate('ASA_TASKS_PAGE_SETUP_WIDGET_STAT_TITLE', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_SETUP_WIDGET_STAT_SUBTITLE() {
    return this._translate('ASA_TASKS_PAGE_SETUP_WIDGET_STAT_SUBTITLE', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_SETUP_WIDGET_DETAIL_PERSONA_TITLE() {
    return this._translate('ASA_TASKS_PAGE_SETUP_WIDGET_DETAIL_PERSONA_TITLE', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_SETUP_WIDGET_DETAIL_CALENDAR_TITLE() {
    return this._translate('ASA_TASKS_PAGE_SETUP_WIDGET_DETAIL_CALENDAR_TITLE', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_SETUP_WIDGET_DETAIL_CLIENT_CONTACT_HOURS_TITLE() {
    return this._translate('ASA_TASKS_PAGE_SETUP_WIDGET_DETAIL_CLIENT_CONTACT_HOURS_TITLE', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_SETUP_WIDGET_DETAIL_SIMULATE_UOU_CHAT_TITLE(name) {
    return this._translate('ASA_TASKS_PAGE_SETUP_WIDGET_DETAIL_SIMULATE_UOU_CHAT_TITLE', {
      name
    });
  }
  ASA_TASKS_PAGE_SETUP_WIDGET_DETAIL_FIRST_TASK_TITLE(name, possessive) {
    return this._translate('ASA_TASKS_PAGE_SETUP_WIDGET_DETAIL_FIRST_TASK_TITLE', {
      name,
      possessive
    });
  }
  ASA_TASKS_PAGE_SETUP_WIDGET_DETAIL_RECOMMENDATIONS_TITLE() {
    return this._translate('ASA_TASKS_PAGE_SETUP_WIDGET_DETAIL_RECOMMENDATIONS_TITLE', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_SETUP_WIDGET_DETAIL_SET_WORKING_HOURS_TITLE() {
    return this._translate('ASA_TASKS_PAGE_SETUP_WIDGET_DETAIL_SET_WORKING_HOURS_TITLE', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_SETUP_WIDGET_DETAIL_ADD_MEETING_TYPES(name) {
    return this._translate('ASA_TASKS_PAGE_SETUP_WIDGET_DETAIL_ADD_MEETING_TYPES', {
      name
    });
  }
  ASA_TASKS_PAGE_EMPTY_STATE_TITLE() {
    return this._translate('ASA_TASKS_PAGE_EMPTY_STATE_TITLE', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_EMPTY_STATE_OPEN_TASKS_TITLE() {
    return this._translate('ASA_TASKS_PAGE_EMPTY_STATE_OPEN_TASKS_TITLE', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_EMPTY_STATE_COMPLETED_TASKS_TITLE(name) {
    return this._translate('ASA_TASKS_PAGE_EMPTY_STATE_COMPLETED_TASKS_TITLE', {
      name
    });
  }
  ASA_TASKS_PAGE_EMPTY_STATE_SUBTITLE(name, pronoun1, pronoun2) {
    return this._translate('ASA_TASKS_PAGE_EMPTY_STATE_SUBTITLE', {
      name,
      pronoun1,
      pronoun2
    });
  }
  ASA_TASKS_PAGE_EMPTY_STATE_OPEN_TASKS_SUBTITLE(name, pronoun) {
    return this._translate('ASA_TASKS_PAGE_EMPTY_STATE_OPEN_TASKS_SUBTITLE', {
      name,
      pronoun
    });
  }
  ASA_TASKS_PAGE_EMPTY_STATE_OPEN_TASKS_CTA(name) {
    return this._translate('ASA_TASKS_PAGE_EMPTY_STATE_OPEN_TASKS_CTA', {
      name
    });
  }
  ASA_TASKS_PAGE_EMPTY_STATE_COMPLETED_TASKS_SUBTITLE(name, pronoun) {
    return this._translate('ASA_TASKS_PAGE_EMPTY_STATE_COMPLETED_TASKS_SUBTITLE', {
      name,
      pronoun
    });
  }
  ASA_TASKS_PAGE_EMPTY_STATE_COMPLETED_TASKS_CTA(name) {
    return this._translate('ASA_TASKS_PAGE_EMPTY_STATE_COMPLETED_TASKS_CTA', {
      name
    });
  }
  ASA_TASKS_PAGE_EMPTY_STATE_WITH_RECOMMENDATIONS_TITLE(name) {
    return this._translate('ASA_TASKS_PAGE_EMPTY_STATE_WITH_RECOMMENDATIONS_TITLE', {
      name
    });
  }
  ASA_TASKS_PAGE_EMPTY_STATE_WITH_RECOMMENDATIONS_SUBTITLE(name) {
    return this._translate('ASA_TASKS_PAGE_EMPTY_STATE_WITH_RECOMMENDATIONS_SUBTITLE', {
      name
    });
  }
  ASA_TASKS_PAGE_EMPTY_STATE_WITH_RECOMMENDATIONS_FOOTER(count) {
    return this._translate('ASA_TASKS_PAGE_EMPTY_STATE_WITH_RECOMMENDATIONS_FOOTER', {
      count
    });
  }
  ASA_TASKS_PAGE_EMPTY_STATE_WITH_RECOMMENDATIONS_VIEW_CTA(name) {
    return this._translate('ASA_TASKS_PAGE_EMPTY_STATE_WITH_RECOMMENDATIONS_VIEW_CTA', {
      name
    });
  }
  ASA_TASKS_PAGE_EMPTY_STATE_WITH_RECOMMENDATIONS_CREATE_TASK_CTA() {
    return this._translate('ASA_TASKS_PAGE_EMPTY_STATE_WITH_RECOMMENDATIONS_CREATE_TASK_CTA', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_EMPTY_STATE_CTA() {
    return this._translate('ASA_TASKS_PAGE_EMPTY_STATE_CTA', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_EMPTY_STATE_OPEN_TASK_CTA(name) {
    return this._translate('ASA_TASKS_PAGE_EMPTY_STATE_OPEN_TASK_CTA', {
      name
    });
  }
  ASA_TASKS_PAGE_EMPTY_STATE_COMPLETED_CTA() {
    return this._translate('ASA_TASKS_PAGE_EMPTY_STATE_COMPLETED_CTA', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_EMPTY_STATE_FILTER_NO_MATCH_TITLE() {
    return this._translate('ASA_TASKS_PAGE_EMPTY_STATE_FILTER_NO_MATCH_TITLE', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_EMPTY_STATE_FILTER_NO_MATCH_SUBTITLE(name) {
    return this._translate('ASA_TASKS_PAGE_EMPTY_STATE_FILTER_NO_MATCH_SUBTITLE', {
      name
    });
  }
  ASA_TASKS_PAGE_RECOMMENDATIONS_TITLE(name, count) {
    return this._translate('ASA_TASKS_PAGE_RECOMMENDATIONS_TITLE', {
      name,
      count
    });
  }
  ASA_TASKS_PAGE_RECOMMENDATIONS_VIEW_CTA() {
    return this._translate('ASA_TASKS_PAGE_RECOMMENDATIONS_VIEW_CTA', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_RECOMMENDATIONS_HIDE_CTA() {
    return this._translate('ASA_TASKS_PAGE_RECOMMENDATIONS_HIDE_CTA', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_RECOMMENDATIONS_TAG() {
    return this._translate('ASA_TASKS_PAGE_RECOMMENDATIONS_TAG', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_DEFAULT_STATUS_MESSAGE(name) {
    return this._translate('ASA_TASKS_PAGE_DEFAULT_STATUS_MESSAGE', {
      name
    });
  }
  ASA_TASKS_PAGE_PENDING_APPROVAL_STATUS_MESSAGE(task) {
    return this._translate('ASA_TASKS_PAGE_PENDING_APPROVAL_STATUS_MESSAGE', {
      task
    });
  }
  ASA_TASKS_PAGE_COMPLETED_STATUS_MESSAGE(name) {
    return this._translate('ASA_TASKS_PAGE_COMPLETED_STATUS_MESSAGE', {
      name
    });
  }
  ASA_TASKS_PAGE_AWAITING_DETAILS_CTA() {
    return this._translate('ASA_TASKS_PAGE_AWAITING_DETAILS_CTA', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_ACTION_CTA_APPROVE() {
    return this._translate('ASA_TASKS_PAGE_ACTION_CTA_APPROVE', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_TAKE_ACTION_CTA() {
    return this._translate('ASA_TASKS_PAGE_TAKE_ACTION_CTA', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_DELETE_CTA() {
    return this._translate('ASA_TASKS_PAGE_DELETE_CTA', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_SEE_COMMUNICATION_CTA() {
    return this._translate('ASA_TASKS_PAGE_SEE_COMMUNICATION_CTA', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_RESEND_INVITATION_CTA() {
    return this._translate('ASA_TASKS_PAGE_RESEND_INVITATION_CTA', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_RESEND_ANNOUNCEMENT_CTA() {
    return this._translate('ASA_TASKS_PAGE_RESEND_ANNOUNCEMENT_CTA', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_MARK_AS_DONE_CTA() {
    return this._translate('ASA_TASKS_PAGE_MARK_AS_DONE_CTA', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_CHAT_CTA() {
    return this._translate('ASA_TASKS_PAGE_CHAT_CTA', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_SEE_CONVERSATION_CTA() {
    return this._translate('ASA_TASKS_PAGE_SEE_CONVERSATION_CTA', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_NEW_TASK_CTA() {
    return this._translate('ASA_TASKS_PAGE_NEW_TASK_CTA', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_FILTER_CTA() {
    return this._translate('ASA_TASKS_PAGE_FILTER_CTA', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_FILTERS_TITLE() {
    return this._translate('ASA_TASKS_PAGE_FILTERS_TITLE', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_FILTERS_STATUS_TITLE() {
    return this._translate('ASA_TASKS_PAGE_FILTERS_STATUS_TITLE', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_FILTERS_INITIATED_BY_TITLE() {
    return this._translate('ASA_TASKS_PAGE_FILTERS_INITIATED_BY_TITLE', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_FILTERS_FILTERS_APPLIED() {
    return this._translate('ASA_TASKS_PAGE_FILTERS_FILTERS_APPLIED', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_FILTERS_FILTERS_CLEAR_CTA() {
    return this._translate('ASA_TASKS_PAGE_FILTERS_FILTERS_CLEAR_CTA', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_CONFIRM_CTA() {
    return this._translate('ASA_TASKS_PAGE_CONFIRM_CTA', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_DISMISS_CTA() {
    return this._translate('ASA_TASKS_PAGE_DISMISS_CTA', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_CONFIRM_ALL_TOOLTIP() {
    return this._translate('ASA_TASKS_PAGE_CONFIRM_ALL_TOOLTIP', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_DISMISS_ALL_TOOLTIP() {
    return this._translate('ASA_TASKS_PAGE_DISMISS_ALL_TOOLTIP', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_CONFIRM_TOOLTIP() {
    return this._translate('ASA_TASKS_PAGE_CONFIRM_TOOLTIP', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_DISMISS_TOOLTIP() {
    return this._translate('ASA_TASKS_PAGE_DISMISS_TOOLTIP', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_DESCRIPTION_TABLE_COLUMN_TITLE() {
    return this._translate('ASA_TASKS_PAGE_DESCRIPTION_TABLE_COLUMN_TITLE', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_INITIATED_BY_TABLE_COLUMN_TITLE() {
    return this._translate('ASA_TASKS_PAGE_INITIATED_BY_TABLE_COLUMN_TITLE', EMPTY_OBJECT);
  }
  ASA_TASKS_PAGE_STATUS_TABLE_COLUMN_TITLE() {
    return this._translate('ASA_TASKS_PAGE_STATUS_TABLE_COLUMN_TITLE', EMPTY_OBJECT);
  }
  ASA_VIEW_CONVERSATION_MODAL_TITLE(name) {
    return this._translate('ASA_VIEW_CONVERSATION_MODAL_TITLE', {
      name
    });
  }
  ASA_RECOMMENDATIONS_MODAL_TITLE(name, count) {
    return this._translate('ASA_RECOMMENDATIONS_MODAL_TITLE', {
      name,
      count
    });
  }
  ASA_RECOMMENDATIONS_MODAL_SUBTITLE(name, count) {
    return this._translate('ASA_RECOMMENDATIONS_MODAL_SUBTITLE', {
      name,
      count
    });
  }
  ASA_RECOMMENDATIONS_MODAL_CREATE_TASK_CTA() {
    return this._translate('ASA_RECOMMENDATIONS_MODAL_CREATE_TASK_CTA', EMPTY_OBJECT);
  }
  ASA_RECOMMENDATIONS_MODAL_CREATED_TASK_LABEL() {
    return this._translate('ASA_RECOMMENDATIONS_MODAL_CREATED_TASK_LABEL', EMPTY_OBJECT);
  }
  ASA_RECOMMENDATIONS_MODAL_PRIMARY_CTA() {
    return this._translate('ASA_RECOMMENDATIONS_MODAL_PRIMARY_CTA', EMPTY_OBJECT);
  }
  ASA_RECOMMENDATIONS_MODAL_SECONDARY_CTA() {
    return this._translate('ASA_RECOMMENDATIONS_MODAL_SECONDARY_CTA', EMPTY_OBJECT);
  }
  ASA_ONBOARDING_NEXT_CTA() {
    return this._translate('ASA_ONBOARDING_NEXT_CTA', EMPTY_OBJECT);
  }
  ASA_ONBOARDING_SKIP_CTA() {
    return this._translate('ASA_ONBOARDING_SKIP_CTA', EMPTY_OBJECT);
  }
  ASA_ONBOARDING_DONE_CTA() {
    return this._translate('ASA_ONBOARDING_DONE_CTA', EMPTY_OBJECT);
  }
  ASA_ONBOARDING_ASSISTANT_SETTINGS_STEP_TITLE() {
    return this._translate('ASA_ONBOARDING_ASSISTANT_SETTINGS_STEP_TITLE', EMPTY_OBJECT);
  }
  ASA_ONBOARDING_ASSISTANT_SETTINGS_STEP_SUBTITLE() {
    return this._translate('ASA_ONBOARDING_ASSISTANT_SETTINGS_STEP_SUBTITLE', EMPTY_OBJECT);
  }
  ASA_ONBOARDING_ASSISTANT_SETTINGS_STEP_NAME_LABEL() {
    return this._translate('ASA_ONBOARDING_ASSISTANT_SETTINGS_STEP_NAME_LABEL', EMPTY_OBJECT);
  }
  ASA_ONBOARDING_ASSISTANT_SETTINGS_STEP_NAME_PLACEHOLDER() {
    return this._translate('ASA_ONBOARDING_ASSISTANT_SETTINGS_STEP_NAME_PLACEHOLDER', EMPTY_OBJECT);
  }
  ASA_ONBOARDING_ASSISTANT_SETTINGS_STEP_PRONOUN_SELECT_LABEL() {
    return this._translate('ASA_ONBOARDING_ASSISTANT_SETTINGS_STEP_PRONOUN_SELECT_LABEL', EMPTY_OBJECT);
  }
  ASA_ONBOARDING_ASSISTANT_SETTINGS_STEP_AVATAR_STYLE_LABEL() {
    return this._translate('ASA_ONBOARDING_ASSISTANT_SETTINGS_STEP_AVATAR_STYLE_LABEL', EMPTY_OBJECT);
  }
  ASA_ONBOARDING_ASSISTANT_SETTINGS_STEP_UPLOAD_PICTURE() {
    return this._translate('ASA_ONBOARDING_ASSISTANT_SETTINGS_STEP_UPLOAD_PICTURE', EMPTY_OBJECT);
  }
  ASA_ONBOARDING_ASSISTANT_PERSONALITY_STEP_TITLE(name) {
    return this._translate('ASA_ONBOARDING_ASSISTANT_PERSONALITY_STEP_TITLE', {
      name
    });
  }
  ASA_ONBOARDING_ASSISTANT_PERSONALITY_STEP_SUBTITLE(name) {
    return this._translate('ASA_ONBOARDING_ASSISTANT_PERSONALITY_STEP_SUBTITLE', {
      name
    });
  }
  ASA_ONBOARDING_ASSISTANT_PERSONALITY_STEP_ASSISTANT_MESSAGE(name) {
    return this._translate('ASA_ONBOARDING_ASSISTANT_PERSONALITY_STEP_ASSISTANT_MESSAGE', {
      name
    });
  }
  ASA_ONBOARDING_CONNECT_CALENDAR_STEP_TITLE(name) {
    return this._translate('ASA_ONBOARDING_CONNECT_CALENDAR_STEP_TITLE', {
      name
    });
  }
  ASA_ONBOARDING_CONNECT_CALENDAR_STEP_SUBTITLE(name) {
    return this._translate('ASA_ONBOARDING_CONNECT_CALENDAR_STEP_SUBTITLE', {
      name
    });
  }
  ASA_ONBOARDING_CONNECT_CALENDAR_STEP_CONNECT() {
    return this._translate('ASA_ONBOARDING_CONNECT_CALENDAR_STEP_CONNECT', EMPTY_OBJECT);
  }
  ASA_ONBOARDING_CONNECT_CALENDAR_STEP_CONNECTED() {
    return this._translate('ASA_ONBOARDING_CONNECT_CALENDAR_STEP_CONNECTED', EMPTY_OBJECT);
  }
  ASA_ONBOARDING_CONNECT_CALENDAR_STEP_DISCONNECT() {
    return this._translate('ASA_ONBOARDING_CONNECT_CALENDAR_STEP_DISCONNECT', EMPTY_OBJECT);
  }
  ASA_ONBOARDING_CONNECT_CALENDAR_STEP_ASSISTANT_MESSAGE_NO_CALENDARS() {
    return this._translate('ASA_ONBOARDING_CONNECT_CALENDAR_STEP_ASSISTANT_MESSAGE_NO_CALENDARS', EMPTY_OBJECT);
  }
  ASA_ONBOARDING_CONNECT_CALENDAR_STEP_ASSISTANT_MESSAGE_ONE_CALENDAR(calendarName) {
    return this._translate('ASA_ONBOARDING_CONNECT_CALENDAR_STEP_ASSISTANT_MESSAGE_ONE_CALENDAR', {
      calendarName
    });
  }
  ASA_ONBOARDING_CONNECT_CALENDAR_STEP_ASSISTANT_MESSAGE_SEVERAL_CALENDARS() {
    return this._translate('ASA_ONBOARDING_CONNECT_CALENDAR_STEP_ASSISTANT_MESSAGE_SEVERAL_CALENDARS', EMPTY_OBJECT);
  }
  ASA_ONBOARDING_CONTACT_HOURS_STEP_TITLE(name, pronoun) {
    return this._translate('ASA_ONBOARDING_CONTACT_HOURS_STEP_TITLE', {
      name,
      pronoun
    });
  }
  ASA_ONBOARDING_CONTACT_HOURS_STEP_SUBTITLE(name) {
    return this._translate('ASA_ONBOARDING_CONTACT_HOURS_STEP_SUBTITLE', {
      name
    });
  }
  ASA_ONBOARDING_CONTACT_HOURS_STEP_ASSISTANT_MESSAGE() {
    return this._translate('ASA_ONBOARDING_CONTACT_HOURS_STEP_ASSISTANT_MESSAGE', EMPTY_OBJECT);
  }
  ASA_ONBOARDING_WORKING_HOURS_STEP_TITLE() {
    return this._translate('ASA_ONBOARDING_WORKING_HOURS_STEP_TITLE', EMPTY_OBJECT);
  }
  ASA_ONBOARDING_WORKING_HOURS_STEP_SUBTITLE(name) {
    return this._translate('ASA_ONBOARDING_WORKING_HOURS_STEP_SUBTITLE', {
      name
    });
  }
  ASA_ONBOARDING_WORKING_HOURS_STEP_ASSISTANT_MESSAGE() {
    return this._translate('ASA_ONBOARDING_WORKING_HOURS_STEP_ASSISTANT_MESSAGE', EMPTY_OBJECT);
  }
  ASA_CALENDAR_PROVIDER_WIX_BOOKING_TITLE() {
    return this._translate('ASA_CALENDAR_PROVIDER_WIX_BOOKING_TITLE', EMPTY_OBJECT);
  }
  ASA_CALENDAR_PROVIDER_WIX_BOOKING_SUBTITLE() {
    return this._translate('ASA_CALENDAR_PROVIDER_WIX_BOOKING_SUBTITLE', EMPTY_OBJECT);
  }
  ASA_CALENDAR_PROVIDER_GOOGLE_TITLE() {
    return this._translate('ASA_CALENDAR_PROVIDER_GOOGLE_TITLE', EMPTY_OBJECT);
  }
  ASA_CALENDAR_PROVIDER_GOOGLE_SUBTITLE() {
    return this._translate('ASA_CALENDAR_PROVIDER_GOOGLE_SUBTITLE', EMPTY_OBJECT);
  }
  ASA_CALENDAR_PROVIDER_MICROSOFT_TITLE() {
    return this._translate('ASA_CALENDAR_PROVIDER_MICROSOFT_TITLE', EMPTY_OBJECT);
  }
  ASA_CALENDAR_PROVIDER_MICROSOFT_SUBTITLE() {
    return this._translate('ASA_CALENDAR_PROVIDER_MICROSOFT_SUBTITLE', EMPTY_OBJECT);
  }
  ASA_CALENDAR_PROVIDER_APPLE_TITLE() {
    return this._translate('ASA_CALENDAR_PROVIDER_APPLE_TITLE', EMPTY_OBJECT);
  }
  ASA_CALENDAR_PROVIDER_APPLE_SUBTITLE() {
    return this._translate('ASA_CALENDAR_PROVIDER_APPLE_SUBTITLE', EMPTY_OBJECT);
  }
  ASA_CONNECT_BOOKING_MODAL_TITLE() {
    return this._translate('ASA_CONNECT_BOOKING_MODAL_TITLE', EMPTY_OBJECT);
  }
  ASA_CONNECT_BOOKING_MODAL_SUBTITLE(name) {
    return this._translate('ASA_CONNECT_BOOKING_MODAL_SUBTITLE', {
      name
    });
  }
  ASA_CONNECT_BOOKING_MODAL_CTA() {
    return this._translate('ASA_CONNECT_BOOKING_MODAL_CTA', EMPTY_OBJECT);
  }
  ASA_ACTIVITY_LOG_PAGE_TITLE() {
    return this._translate('ASA_ACTIVITY_LOG_PAGE_TITLE', EMPTY_OBJECT);
  }
  ASA_CALENDARS_PAGE_TITLE() {
    return this._translate('ASA_CALENDARS_PAGE_TITLE', EMPTY_OBJECT);
  }
  ASA_CALENDARS_PAGE_SUBTITLE(name) {
    return this._translate('ASA_CALENDARS_PAGE_SUBTITLE', {
      name
    });
  }
  ASA_CALENDARS_CARD_SCHEDULE_PREFERENCES_TITLE() {
    return this._translate('ASA_CALENDARS_CARD_SCHEDULE_PREFERENCES_TITLE', EMPTY_OBJECT);
  }
  ASA_CALENDARS_CARD_SCHEDULE_PREFERENCES_PLACEHOLDER() {
    return this._translate('ASA_CALENDARS_CARD_SCHEDULE_PREFERENCES_PLACEHOLDER', EMPTY_OBJECT);
  }
  ASA_CALENDARS_CARD_CONNECT_CTA() {
    return this._translate('ASA_CALENDARS_CARD_CONNECT_CTA', EMPTY_OBJECT);
  }
  ASA_CALENDARS_CARD_DISCONNECT_CTA() {
    return this._translate('ASA_CALENDARS_CARD_DISCONNECT_CTA', EMPTY_OBJECT);
  }
  ASA_CALENDARS_CARD_CONNECTION_DISABLED_TOOLTIP_TEXT() {
    return this._translate('ASA_CALENDARS_CARD_CONNECTION_DISABLED_TOOLTIP_TEXT', EMPTY_OBJECT);
  }
  ASA_CALENDARS_CARD_ADD_ACCOUNT_CTA() {
    return this._translate('ASA_CALENDARS_CARD_ADD_ACCOUNT_CTA', EMPTY_OBJECT);
  }
  ASA_CALENDARS_CARD_BOOKINGS_MANAGE_CTA() {
    return this._translate('ASA_CALENDARS_CARD_BOOKINGS_MANAGE_CTA', EMPTY_OBJECT);
  }
  ASA_CALENDARS_CARD_BOOKINGS_SERVICES_TABLE_TITLE() {
    return this._translate('ASA_CALENDARS_CARD_BOOKINGS_SERVICES_TABLE_TITLE', EMPTY_OBJECT);
  }
  ASA_CALENDARS_CARD_BOOKINGS_FOOTER_DISCLAIMER() {
    return this._translate('ASA_CALENDARS_CARD_BOOKINGS_FOOTER_DISCLAIMER', EMPTY_OBJECT);
  }
  ASA_CALENDARS_CARD_BOOKINGS_FOOTER_DISCLAIMER_SERVICES_NAME() {
    return this._translate('ASA_CALENDARS_CARD_BOOKINGS_FOOTER_DISCLAIMER_SERVICES_NAME', EMPTY_OBJECT);
  }
  ASA_CALENDARS_CARD_BOOKINGS_FOOTER_DISCLAIMER_EMPTY() {
    return this._translate('ASA_CALENDARS_CARD_BOOKINGS_FOOTER_DISCLAIMER_EMPTY', EMPTY_OBJECT);
  }
  ASA_CALENDARS_CARD_PERSONAL_SERVICES_TABLE_TITLE() {
    return this._translate('ASA_CALENDARS_CARD_PERSONAL_SERVICES_TABLE_TITLE', EMPTY_OBJECT);
  }
  ASA_CALENDARS_CARD_SERVICES_TABLE_NAME_TITLE() {
    return this._translate('ASA_CALENDARS_CARD_SERVICES_TABLE_NAME_TITLE', EMPTY_OBJECT);
  }
  ASA_CALENDARS_CARD_SERVICES_TABLE_GUIDANCE_TITLE() {
    return this._translate('ASA_CALENDARS_CARD_SERVICES_TABLE_GUIDANCE_TITLE', EMPTY_OBJECT);
  }
  ASA_CALENDARS_CARD_SERVICES_TABLE_NO_GUIDANCE_TEXT() {
    return this._translate('ASA_CALENDARS_CARD_SERVICES_TABLE_NO_GUIDANCE_TEXT', EMPTY_OBJECT);
  }
  ASA_CALENDARS_CARD_SERVICES_TABLE_DEFAULT_SERVICE_DISCLAIMER() {
    return this._translate('ASA_CALENDARS_CARD_SERVICES_TABLE_DEFAULT_SERVICE_DISCLAIMER', EMPTY_OBJECT);
  }
  ASA_CALENDARS_CARD_SERVICES_TABLE_NO_GUIDANCE_TEXT_DEFAULT_TIME() {
    return this._translate('ASA_CALENDARS_CARD_SERVICES_TABLE_NO_GUIDANCE_TEXT_DEFAULT_TIME', EMPTY_OBJECT);
  }
  ASA_CALENDARS_CARD_SERVICES_TABLE_VIRTUAL_TAG() {
    return this._translate('ASA_CALENDARS_CARD_SERVICES_TABLE_VIRTUAL_TAG', EMPTY_OBJECT);
  }
  ASA_CALENDARS_CARD_SERVICES_TABLE_ADD_CTA() {
    return this._translate('ASA_CALENDARS_CARD_SERVICES_TABLE_ADD_CTA', EMPTY_OBJECT);
  }
  ASA_CALENDARS_SERVICE_MODAL_BOOKINGS_SUBTITLE() {
    return this._translate('ASA_CALENDARS_SERVICE_MODAL_BOOKINGS_SUBTITLE', EMPTY_OBJECT);
  }
  ASA_CALENDARS_SERVICE_MODAL_BOOKINGS_SUBTITLE_CTA() {
    return this._translate('ASA_CALENDARS_SERVICE_MODAL_BOOKINGS_SUBTITLE_CTA', EMPTY_OBJECT);
  }
  ASA_CALENDARS_SERVICE_MODAL_NAME_TITLE() {
    return this._translate('ASA_CALENDARS_SERVICE_MODAL_NAME_TITLE', EMPTY_OBJECT);
  }
  ASA_CALENDARS_SERVICE_MODAL_NAME_PLACEHOLDER() {
    return this._translate('ASA_CALENDARS_SERVICE_MODAL_NAME_PLACEHOLDER', EMPTY_OBJECT);
  }
  ASA_CALENDARS_SERVICE_MODAL_GUIDANCE_TITLE() {
    return this._translate('ASA_CALENDARS_SERVICE_MODAL_GUIDANCE_TITLE', EMPTY_OBJECT);
  }
  ASA_CALENDARS_SERVICE_MODAL_GUIDANCE_PLACEHOLDER() {
    return this._translate('ASA_CALENDARS_SERVICE_MODAL_GUIDANCE_PLACEHOLDER', EMPTY_OBJECT);
  }
  ASA_CALENDARS_SERVICE_MODAL_GUIDANCE_DISCLAIMER_DEFAULT_TIME() {
    return this._translate('ASA_CALENDARS_SERVICE_MODAL_GUIDANCE_DISCLAIMER_DEFAULT_TIME', EMPTY_OBJECT);
  }
  ASA_CALENDARS_SERVICE_MODAL_GUIDANCE_BOOKING_PLACEHOLDER(name) {
    return this._translate('ASA_CALENDARS_SERVICE_MODAL_GUIDANCE_BOOKING_PLACEHOLDER', {
      name
    });
  }
  ASA_CALENDARS_SERVICE_MODAL_NEW_TITLE() {
    return this._translate('ASA_CALENDARS_SERVICE_MODAL_NEW_TITLE', EMPTY_OBJECT);
  }
  ASA_CALENDARS_SERVICE_MODAL_EDIT_TITLE() {
    return this._translate('ASA_CALENDARS_SERVICE_MODAL_EDIT_TITLE', EMPTY_OBJECT);
  }
  ASA_CALENDARS_SERVICE_MODAL_VIRTUAL_MEETING_TOGGLE() {
    return this._translate('ASA_CALENDARS_SERVICE_MODAL_VIRTUAL_MEETING_TOGGLE', EMPTY_OBJECT);
  }
  ASA_CALENDARS_SERVICE_MODAL_VIRTUAL_MEETING_DESCRIPTION() {
    return this._translate('ASA_CALENDARS_SERVICE_MODAL_VIRTUAL_MEETING_DESCRIPTION', EMPTY_OBJECT);
  }
  ASA_CALENDARS_SERVICE_MODAL_SAVE_CTA() {
    return this._translate('ASA_CALENDARS_SERVICE_MODAL_SAVE_CTA', EMPTY_OBJECT);
  }
  ASA_CALENDARS_SERVICE_MODAL_CANCEL_CTA() {
    return this._translate('ASA_CALENDARS_SERVICE_MODAL_CANCEL_CTA', EMPTY_OBJECT);
  }
  ASA_CHAT_EMPTY_STATE_TITLE(name) {
    return this._translate('ASA_CHAT_EMPTY_STATE_TITLE', {
      name
    });
  }
  ASA_CHAT_EMPTY_STATE_TITLE_NO_NAME() {
    return this._translate('ASA_CHAT_EMPTY_STATE_TITLE_NO_NAME', EMPTY_OBJECT);
  }
  ASA_CHAT_EMPTY_STATE_SUBTITLE() {
    return this._translate('ASA_CHAT_EMPTY_STATE_SUBTITLE', EMPTY_OBJECT);
  }
  ASA_CHAT_EMPTY_STATE_TASK_RECURRING() {
    return this._translate('ASA_CHAT_EMPTY_STATE_TASK_RECURRING', EMPTY_OBJECT);
  }
  ASA_CHAT_EMPTY_STATE_TASK_CLEAR() {
    return this._translate('ASA_CHAT_EMPTY_STATE_TASK_CLEAR', EMPTY_OBJECT);
  }
  ASA_CHAT_EMPTY_STATE_TASK_RESCHEDULE() {
    return this._translate('ASA_CHAT_EMPTY_STATE_TASK_RESCHEDULE', EMPTY_OBJECT);
  }
  ASA_CHAT_EMPTY_STATE_TASK_ONE_TIME() {
    return this._translate('ASA_CHAT_EMPTY_STATE_TASK_ONE_TIME', EMPTY_OBJECT);
  }
  ASA_CHAT_EMPTY_STATE_TASK_SCHEDULE_MEETING() {
    return this._translate('ASA_CHAT_EMPTY_STATE_TASK_SCHEDULE_MEETING', EMPTY_OBJECT);
  }
  ASA_CHAT_EMPTY_STATE_TASK_CREATE_LINK() {
    return this._translate('ASA_CHAT_EMPTY_STATE_TASK_CREATE_LINK', EMPTY_OBJECT);
  }
  ASA_CHAT_EMPTY_STATE_TASK_INFO_ABOUT_MEETINGS() {
    return this._translate('ASA_CHAT_EMPTY_STATE_TASK_INFO_ABOUT_MEETINGS', EMPTY_OBJECT);
  }
  ASA_CHAT_EMPTY_STATE_INPUT_PLACEHOLDER() {
    return this._translate('ASA_CHAT_EMPTY_STATE_INPUT_PLACEHOLDER', EMPTY_OBJECT);
  }
  ASA_CALENDARS_SCHEDULING_PREFERENCES_MODAL_TITLE() {
    return this._translate('ASA_CALENDARS_SCHEDULING_PREFERENCES_MODAL_TITLE', EMPTY_OBJECT);
  }
  ASA_CALENDARS_SCHEDULING_PREFERENCES_MODAL_SUBTITLE(name) {
    return this._translate('ASA_CALENDARS_SCHEDULING_PREFERENCES_MODAL_SUBTITLE', {
      name
    });
  }
  ASA_CALENDARS_SCHEDULING_PREFERENCES_MODAL_AVAILABILITY_HOURS_TITLE() {
    return this._translate('ASA_CALENDARS_SCHEDULING_PREFERENCES_MODAL_AVAILABILITY_HOURS_TITLE', EMPTY_OBJECT);
  }
  ASA_CALENDARS_SCHEDULING_PREFERENCES_MODAL_AVAILABILITY_HOURS_MATCH_CALENDAR_TITLE() {
    return this._translate('ASA_CALENDARS_SCHEDULING_PREFERENCES_MODAL_AVAILABILITY_HOURS_MATCH_CALENDAR_TITLE', EMPTY_OBJECT);
  }
  ASA_CALENDARS_SCHEDULING_PREFERENCES_MODAL_AVAILABILITY_HOURS_MATCH_CALENDAR_SUBTITLE(name) {
    return this._translate('ASA_CALENDARS_SCHEDULING_PREFERENCES_MODAL_AVAILABILITY_HOURS_MATCH_CALENDAR_SUBTITLE', {
      name
    });
  }
  ASA_CALENDARS_SCHEDULING_PREFERENCES_MODAL_AVAILABILITY_HOURS_CUSTOM_TITLE() {
    return this._translate('ASA_CALENDARS_SCHEDULING_PREFERENCES_MODAL_AVAILABILITY_HOURS_CUSTOM_TITLE', EMPTY_OBJECT);
  }
  ASA_CALENDARS_SCHEDULING_PREFERENCES_MODAL_AVAILABILITY_HOURS_CUSTOM_SUBTITLE() {
    return this._translate('ASA_CALENDARS_SCHEDULING_PREFERENCES_MODAL_AVAILABILITY_HOURS_CUSTOM_SUBTITLE', EMPTY_OBJECT);
  }
  ASA_CALENDARS_SCHEDULING_PREFERENCES_MODAL_GUIDELINES_TITLE() {
    return this._translate('ASA_CALENDARS_SCHEDULING_PREFERENCES_MODAL_GUIDELINES_TITLE', EMPTY_OBJECT);
  }
  ASA_CALENDARS_SCHEDULING_PREFERENCES_MODAL_GUIDELINES_PLACEHOLDER() {
    return this._translate('ASA_CALENDARS_SCHEDULING_PREFERENCES_MODAL_GUIDELINES_PLACEHOLDER', EMPTY_OBJECT);
  }
  ASA_CALENDARS_SCHEDULING_PREFERENCES_MODAL_SAVE_CTA() {
    return this._translate('ASA_CALENDARS_SCHEDULING_PREFERENCES_MODAL_SAVE_CTA', EMPTY_OBJECT);
  }
  ASA_CALENDARS_SCHEDULING_PREFERENCES_MODAL_CANCEL_CTA() {
    return this._translate('ASA_CALENDARS_SCHEDULING_PREFERENCES_MODAL_CANCEL_CTA', EMPTY_OBJECT);
  }
  ASA_DISCONNECT_CALENDAR_MODAL_TITLE(calendarName) {
    return this._translate('ASA_DISCONNECT_CALENDAR_MODAL_TITLE', {
      calendarName
    });
  }
  ASA_DISCONNECT_CALENDAR_MODAL_SUBTITLE(agentName, calendarName) {
    return this._translate('ASA_DISCONNECT_CALENDAR_MODAL_SUBTITLE', {
      agentName,
      calendarName
    });
  }
  ASA_DISCONNECT_CALENDAR_MODAL_DISCONNECT_CTA() {
    return this._translate('ASA_DISCONNECT_CALENDAR_MODAL_DISCONNECT_CTA', EMPTY_OBJECT);
  }
  ASA_DISCONNECT_CALENDAR_MODAL_CANCEL_CTA() {
    return this._translate('ASA_DISCONNECT_CALENDAR_MODAL_CANCEL_CTA', EMPTY_OBJECT);
  }
  ASA_DELETE_MEETING_TYPE_MODAL_TITLE(name) {
    return this._translate('ASA_DELETE_MEETING_TYPE_MODAL_TITLE', {
      name
    });
  }
  ASA_DELETE_MEETING_TYPE_MODAL_SUBTITLE() {
    return this._translate('ASA_DELETE_MEETING_TYPE_MODAL_SUBTITLE', EMPTY_OBJECT);
  }
  ASA_DELETE_MEETING_TYPE_MODAL_DELETE_CTA() {
    return this._translate('ASA_DELETE_MEETING_TYPE_MODAL_DELETE_CTA', EMPTY_OBJECT);
  }
  ASA_DELETE_MEETING_TYPE_MODAL_CANCEL_CTA() {
    return this._translate('ASA_DELETE_MEETING_TYPE_MODAL_CANCEL_CTA', EMPTY_OBJECT);
  }
  ASA_CANCEL_RECURRING_SCHEDULE_MODAL_TITLE(serviceName, frequency, contactName) {
    return this._translate('ASA_CANCEL_RECURRING_SCHEDULE_MODAL_TITLE', {
      serviceName,
      frequency,
      contactName
    });
  }
  ASA_CANCEL_RECURRING_SCHEDULE_MODAL_SUBTITLE(agentName) {
    return this._translate('ASA_CANCEL_RECURRING_SCHEDULE_MODAL_SUBTITLE', {
      agentName
    });
  }
  ASA_CANCEL_RECURRING_SCHEDULE_MODAL_CANCEL_RECURRING_CTA() {
    return this._translate('ASA_CANCEL_RECURRING_SCHEDULE_MODAL_CANCEL_RECURRING_CTA', EMPTY_OBJECT);
  }
  ASA_CANCEL_RECURRING_SCHEDULE_MODAL_CANCEL_CTA() {
    return this._translate('ASA_CANCEL_RECURRING_SCHEDULE_MODAL_CANCEL_CTA', EMPTY_OBJECT);
  }
  ASA_CONNECT_CALENDAR_MODAL_CONNECT_CTA() {
    return this._translate('ASA_CONNECT_CALENDAR_MODAL_CONNECT_CTA', EMPTY_OBJECT);
  }
  ASA_CONNECT_CALENDAR_MODAL_TITLE() {
    return this._translate('ASA_CONNECT_CALENDAR_MODAL_TITLE', EMPTY_OBJECT);
  }
  ASA_CONNECT_CALENDAR_MODAL_SUBTITLE(name) {
    return this._translate('ASA_CONNECT_CALENDAR_MODAL_SUBTITLE', {
      name
    });
  }
  ASA_CONNECT_CALENDAR_MODAL_FOOTNOTE() {
    return this._translate('ASA_CONNECT_CALENDAR_MODAL_FOOTNOTE', EMPTY_OBJECT);
  }
  ASA_CREATE_TASK_MODAL_TITLE(name) {
    return this._translate('ASA_CREATE_TASK_MODAL_TITLE', {
      name
    });
  }
  ASA_CREATE_TASK_MODAL_SUBTITLE(pronoun) {
    return this._translate('ASA_CREATE_TASK_MODAL_SUBTITLE', {
      pronoun
    });
  }
  ASA_CREATE_TASK_MODAL_INPUT_PLACEHOLDER() {
    return this._translate('ASA_CREATE_TASK_MODAL_INPUT_PLACEHOLDER', EMPTY_OBJECT);
  }
  ASA_CREATE_TASK_MODAL_CANCEL_CTA() {
    return this._translate('ASA_CREATE_TASK_MODAL_CANCEL_CTA', EMPTY_OBJECT);
  }
  ASA_CREATE_TASK_MODAL_CREATE_CTA() {
    return this._translate('ASA_CREATE_TASK_MODAL_CREATE_CTA', EMPTY_OBJECT);
  }
  ASA_DELETE_TASK_MODAL_TITLE(name) {
    return this._translate('ASA_DELETE_TASK_MODAL_TITLE', {
      name
    });
  }
  ASA_DELETE_TASK_MODAL_SUBTITLE() {
    return this._translate('ASA_DELETE_TASK_MODAL_SUBTITLE', EMPTY_OBJECT);
  }
  ASA_DELETE_TASK_MODAL_SUBTITLE_IN_PROGRESS(name) {
    return this._translate('ASA_DELETE_TASK_MODAL_SUBTITLE_IN_PROGRESS', {
      name
    });
  }
  ASA_DELETE_TASK_MODAL_DELETE_CTA() {
    return this._translate('ASA_DELETE_TASK_MODAL_DELETE_CTA', EMPTY_OBJECT);
  }
  ASA_DELETE_TASK_MODAL_CANCEL_CTA() {
    return this._translate('ASA_DELETE_TASK_MODAL_CANCEL_CTA', EMPTY_OBJECT);
  }
  ASA_DELETE_ACTION_MODAL_TITLE(name) {
    return this._translate('ASA_DELETE_ACTION_MODAL_TITLE', {
      name
    });
  }
  ASA_DELETE_ACTION_MODAL_SUBTITLE(name) {
    return this._translate('ASA_DELETE_ACTION_MODAL_SUBTITLE', {
      name
    });
  }
  ASA_DELETE_ACTION_MODAL_DELETE_CTA() {
    return this._translate('ASA_DELETE_ACTION_MODAL_DELETE_CTA', EMPTY_OBJECT);
  }
  ASA_DELETE_ACTION_MODAL_CANCEL_CTA() {
    return this._translate('ASA_DELETE_ACTION_MODAL_CANCEL_CTA', EMPTY_OBJECT);
  }
  ASA_UPDATE_TASK_MODAL_TITLE() {
    return this._translate('ASA_UPDATE_TASK_MODAL_TITLE', EMPTY_OBJECT);
  }
  ASA_UPDATE_TASK_MODAL_PARTICIPANT_LABEL() {
    return this._translate('ASA_UPDATE_TASK_MODAL_PARTICIPANT_LABEL', EMPTY_OBJECT);
  }
  ASA_UPDATE_TASK_MODAL_ACTION_LABEL() {
    return this._translate('ASA_UPDATE_TASK_MODAL_ACTION_LABEL', EMPTY_OBJECT);
  }
  ASA_UPDATE_TASK_MODAL_ACTION_RESCHEDULE() {
    return this._translate('ASA_UPDATE_TASK_MODAL_ACTION_RESCHEDULE', EMPTY_OBJECT);
  }
  ASA_UPDATE_TASK_MODAL_ACTION_RESCHEDULE_INFO() {
    return this._translate('ASA_UPDATE_TASK_MODAL_ACTION_RESCHEDULE_INFO', EMPTY_OBJECT);
  }
  ASA_UPDATE_TASK_MODAL_ACTION_CANCEL() {
    return this._translate('ASA_UPDATE_TASK_MODAL_ACTION_CANCEL', EMPTY_OBJECT);
  }
  ASA_UPDATE_TASK_MODAL_ACTION_CANCEL_INFO() {
    return this._translate('ASA_UPDATE_TASK_MODAL_ACTION_CANCEL_INFO', EMPTY_OBJECT);
  }
  ASA_UPDATE_TASK_MODAL_SAVE_CTA() {
    return this._translate('ASA_UPDATE_TASK_MODAL_SAVE_CTA', EMPTY_OBJECT);
  }
  ASA_UPDATE_TASK_MODAL_CANCEL_CTA() {
    return this._translate('ASA_UPDATE_TASK_MODAL_CANCEL_CTA', EMPTY_OBJECT);
  }
  ASA_ACTION_STATUS_ACTION_NEEDED() {
    return this._translate('ASA_ACTION_STATUS_ACTION_NEEDED', EMPTY_OBJECT);
  }
  ASA_ACTION_STATUS_CANCELED() {
    return this._translate('ASA_ACTION_STATUS_CANCELED', EMPTY_OBJECT);
  }
  ASA_ACTION_STATUS_COMPLETE() {
    return this._translate('ASA_ACTION_STATUS_COMPLETE', EMPTY_OBJECT);
  }
  ASA_ACTION_STATUS_INVALID() {
    return this._translate('ASA_ACTION_STATUS_INVALID', EMPTY_OBJECT);
  }
  ASA_ACTION_STATUS_IN_PROGRESS() {
    return this._translate('ASA_ACTION_STATUS_IN_PROGRESS', EMPTY_OBJECT);
  }
  ASA_ACTION_STATUS_PENDING_APPROVAL() {
    return this._translate('ASA_ACTION_STATUS_PENDING_APPROVAL', EMPTY_OBJECT);
  }
  ASA_ACTION_STATUS_FAILED() {
    return this._translate('ASA_ACTION_STATUS_FAILED', EMPTY_OBJECT);
  }
  ASA_TASK_STATUS_ACTION_NEEDED() {
    return this._translate('ASA_TASK_STATUS_ACTION_NEEDED', EMPTY_OBJECT);
  }
  ASA_TASK_STATUS_AWAITING_ANALYSIS() {
    return this._translate('ASA_TASK_STATUS_AWAITING_ANALYSIS', EMPTY_OBJECT);
  }
  ASA_TASK_STATUS_AWAITING_DETAILS() {
    return this._translate('ASA_TASK_STATUS_AWAITING_DETAILS', EMPTY_OBJECT);
  }
  ASA_TASK_STATUS_CANCELED() {
    return this._translate('ASA_TASK_STATUS_CANCELED', EMPTY_OBJECT);
  }
  ASA_TASK_STATUS_COMPLETE() {
    return this._translate('ASA_TASK_STATUS_COMPLETE', EMPTY_OBJECT);
  }
  ASA_TASK_STATUS_FAILED() {
    return this._translate('ASA_TASK_STATUS_FAILED', EMPTY_OBJECT);
  }
  ASA_TASK_STATUS_IN_PROGRESS() {
    return this._translate('ASA_TASK_STATUS_IN_PROGRESS', EMPTY_OBJECT);
  }
  ASA_TASK_STATUS_PENDING_APPROVAL() {
    return this._translate('ASA_TASK_STATUS_PENDING_APPROVAL', EMPTY_OBJECT);
  }
  ASA_TASK_SOURCE_ANONYMOUS_LINK() {
    return this._translate('ASA_TASK_SOURCE_ANONYMOUS_LINK', EMPTY_OBJECT);
  }
  ASA_TASK_SOURCE_CHAT() {
    return this._translate('ASA_TASK_SOURCE_CHAT', EMPTY_OBJECT);
  }
  ASA_TASK_SOURCE_MANUAL() {
    return this._translate('ASA_TASK_SOURCE_MANUAL', EMPTY_OBJECT);
  }
  ASA_TASK_SOURCE_RECURRING_SCHEDULE() {
    return this._translate('ASA_TASK_SOURCE_RECURRING_SCHEDULE', EMPTY_OBJECT);
  }
  ASA_TASK_SOURCE_RECOMMENDATION() {
    return this._translate('ASA_TASK_SOURCE_RECOMMENDATION', EMPTY_OBJECT);
  }
  ASA_CHAT_SHAREABLE_LINK_MODAL_TITLE() {
    return this._translate('ASA_CHAT_SHAREABLE_LINK_MODAL_TITLE', EMPTY_OBJECT);
  }
  ASA_CHAT_SHAREABLE_LINK_MODAL_SUBTITLE(name) {
    return this._translate('ASA_CHAT_SHAREABLE_LINK_MODAL_SUBTITLE', {
      name
    });
  }
  ASA_CHAT_SHAREABLE_LINK_MODAL_COPY_LINK_LABEL() {
    return this._translate('ASA_CHAT_SHAREABLE_LINK_MODAL_COPY_LINK_LABEL', EMPTY_OBJECT);
  }
  ASA_CHAT_SHAREABLE_LINK_MODAL_SHARE_LINK_TITLE() {
    return this._translate('ASA_CHAT_SHAREABLE_LINK_MODAL_SHARE_LINK_TITLE', EMPTY_OBJECT);
  }
  ASA_CHAT_SHAREABLE_LINK_MODAL_QR_TITLE() {
    return this._translate('ASA_CHAT_SHAREABLE_LINK_MODAL_QR_TITLE', EMPTY_OBJECT);
  }
  ASA_CHAT_SHAREABLE_LINK_MODAL_QR_CTA() {
    return this._translate('ASA_CHAT_SHAREABLE_LINK_MODAL_QR_CTA', EMPTY_OBJECT);
  }
  ASA_CHAT_SHAREABLE_LINK_MODAL_WHATSAPP_CTA() {
    return this._translate('ASA_CHAT_SHAREABLE_LINK_MODAL_WHATSAPP_CTA', EMPTY_OBJECT);
  }
  ASA_CHAT_SHAREABLE_LINK_MODAL_TWITTER_CTA() {
    return this._translate('ASA_CHAT_SHAREABLE_LINK_MODAL_TWITTER_CTA', EMPTY_OBJECT);
  }
  ASA_CHAT_SHAREABLE_LINK_MODAL_FACEBOOK_CTA() {
    return this._translate('ASA_CHAT_SHAREABLE_LINK_MODAL_FACEBOOK_CTA', EMPTY_OBJECT);
  }
  ASA_CHAT_SHAREABLE_LINK_MODAL_SHARE_TEXT() {
    return this._translate('ASA_CHAT_SHAREABLE_LINK_MODAL_SHARE_TEXT', EMPTY_OBJECT);
  }
  ASA_SCHEDULING_INSIGHTS_PAGE_TITLE() {
    return this._translate('ASA_SCHEDULING_INSIGHTS_PAGE_TITLE', EMPTY_OBJECT);
  }
  ASA_SCHEDULING_INSIGHTS_PAGE_SUBTITLE(name) {
    return this._translate('ASA_SCHEDULING_INSIGHTS_PAGE_SUBTITLE', {
      name
    });
  }
  ASA_SCHEDULING_INSIGHTS_BOOKED_BY_ASSISTANT_BOX_TEXT(count, name) {
    return this._translate('ASA_SCHEDULING_INSIGHTS_BOOKED_BY_ASSISTANT_BOX_TEXT', {
      count,
      name
    });
  }
  ASA_SCHEDULING_INSIGHTS_REPEATING_BOX_TEXT(percent) {
    return this._translate('ASA_SCHEDULING_INSIGHTS_REPEATING_BOX_TEXT', {
      percent
    });
  }
  ASA_SCHEDULING_INSIGHTS_YET_TO_SCHEDULE_BOX_TEXT(percent) {
    return this._translate('ASA_SCHEDULING_INSIGHTS_YET_TO_SCHEDULE_BOX_TEXT', {
      percent
    });
  }
  ASA_SCHEDULING_INSIGHTS_TABLE_TITLE() {
    return this._translate('ASA_SCHEDULING_INSIGHTS_TABLE_TITLE', EMPTY_OBJECT);
  }
  ASA_SCHEDULING_INSIGHTS_CLIENT_MODAL_TITLE() {
    return this._translate('ASA_SCHEDULING_INSIGHTS_CLIENT_MODAL_TITLE', EMPTY_OBJECT);
  }
  ASA_SCHEDULING_INSIGHTS_TABLE_FILTER_PLACEHOLDER() {
    return this._translate('ASA_SCHEDULING_INSIGHTS_TABLE_FILTER_PLACEHOLDER', EMPTY_OBJECT);
  }
  ASA_SCHEDULING_INSIGHTS_TABLE_SEARCH_PLACEHOLDER() {
    return this._translate('ASA_SCHEDULING_INSIGHTS_TABLE_SEARCH_PLACEHOLDER', EMPTY_OBJECT);
  }
  ASA_SCHEDULING_INSIGHTS_TABLE_NO_NEXT_BOOK() {
    return this._translate('ASA_SCHEDULING_INSIGHTS_TABLE_NO_NEXT_BOOK', EMPTY_OBJECT);
  }
  ASA_SCHEDULING_INSIGHTS_TABLE_FOLLOW_UP_CTA(name) {
    return this._translate('ASA_SCHEDULING_INSIGHTS_TABLE_FOLLOW_UP_CTA', {
      name
    });
  }
  ASA_SCHEDULING_INSIGHTS_TABLE_ACTION_MENU_OPTION_SEE_MORE() {
    return this._translate('ASA_SCHEDULING_INSIGHTS_TABLE_ACTION_MENU_OPTION_SEE_MORE', EMPTY_OBJECT);
  }
  ASA_SCHEDULING_INSIGHTS_TABLE_ACTION_MENU_OPTION_READ_COMMUNICATION() {
    return this._translate('ASA_SCHEDULING_INSIGHTS_TABLE_ACTION_MENU_OPTION_READ_COMMUNICATION', EMPTY_OBJECT);
  }
  ASA_SCHEDULING_INSIGHTS_TABLE_ACTION_MENU_OPTION_VIEW_CLIENT_INFO() {
    return this._translate('ASA_SCHEDULING_INSIGHTS_TABLE_ACTION_MENU_OPTION_VIEW_CLIENT_INFO', EMPTY_OBJECT);
  }
  ASA_SCHEDULING_INSIGHTS_CLIENT_NAME_LABEL() {
    return this._translate('ASA_SCHEDULING_INSIGHTS_CLIENT_NAME_LABEL', EMPTY_OBJECT);
  }
  ASA_SCHEDULING_INSIGHTS_TABLE_INITIATOR_BADGE() {
    return this._translate('ASA_SCHEDULING_INSIGHTS_TABLE_INITIATOR_BADGE:', EMPTY_OBJECT);
  }
  ASA_SCHEDULING_INSIGHTS_MEETING_TYPE_LABEL() {
    return this._translate('ASA_SCHEDULING_INSIGHTS_MEETING_TYPE_LABEL', EMPTY_OBJECT);
  }
  ASA_SCHEDULING_INSIGHTS_BOOKING_INTERVAL_LABEL() {
    return this._translate('ASA_SCHEDULING_INSIGHTS_BOOKING_INTERVAL_LABEL', EMPTY_OBJECT);
  }
  ASA_SCHEDULING_INSIGHTS_NUM_OF_BOOKINGS_LABEL() {
    return this._translate('ASA_SCHEDULING_INSIGHTS_NUM_OF_BOOKINGS_LABEL', EMPTY_OBJECT);
  }
  ASA_SCHEDULING_INSIGHTS_NEXT_BOOKED_LABEL() {
    return this._translate('ASA_SCHEDULING_INSIGHTS_NEXT_BOOKED_LABEL', EMPTY_OBJECT);
  }
  ASA_SCHEDULING_INSIGHTS_LAST_BOOKED_LABEL() {
    return this._translate('ASA_SCHEDULING_INSIGHTS_LAST_BOOKED_LABEL', EMPTY_OBJECT);
  }
  ASA_SCHEDULING_INSIGHTS_INITIATOR_LABEL() {
    return this._translate('ASA_SCHEDULING_INSIGHTS_INITIATOR_LABEL', EMPTY_OBJECT);
  }
  ASA_SCHEDULING_INSIGHTS_INSIGHTS_LABEL() {
    return this._translate('ASA_SCHEDULING_INSIGHTS_INSIGHTS_LABEL', EMPTY_OBJECT);
  }
  ASA_PAGE_BREADCRUBS_ALPHA_TAG() {
    return this._translate('ASA_PAGE_BREADCRUBS_ALPHA_TAG', EMPTY_OBJECT);
  }
  ASA_PAGE_BREADCRUBS_FEEDBACK_BUTTON() {
    return this._translate('ASA_PAGE_BREADCRUBS_FEEDBACK_BUTTON', EMPTY_OBJECT);
  }
  FEEDBACK_EMAIL_SUBJECT() {
    return this._translate('FEEDBACK_EMAIL_SUBJECT', EMPTY_OBJECT);
  }
  ASA_PAGE_BREADCRUBS_ALPHA_TAG_TOOLTIP() {
    return this._translate('ASA_PAGE_BREADCRUBS_ALPHA_TAG_TOOLTIP', EMPTY_OBJECT);
  }
  ASA_SCHEDULING_INSIGHTS_COMPLETED_SESSIONS_TOOLTIP(name) {
    return this._translate('ASA_SCHEDULING_INSIGHTS_COMPLETED_SESSIONS_TOOLTIP', {
      name
    });
  }
  ASA_GET_STARTED_ASSISTANT_INTRO_TITLE_AB_TRANSLATE_1_SPECS_ORION_INTRO_SCREEN() {
    return this._translate('ASA_GET_STARTED_ASSISTANT_INTRO_TITLE|abTranslate_1|specs.orion.introScreen', EMPTY_OBJECT);
  }
  ASA_GET_STARTED_ASSISTANT_INTRO_TITLE_AB_TRANSLATE_2_SPECS_ORION_INTRO_SCREEN() {
    return this._translate('ASA_GET_STARTED_ASSISTANT_INTRO_TITLE|abTranslate_2|specs.orion.introScreen', EMPTY_OBJECT);
  }
  ASA_GET_STARTED_ASSISTANT_INTRO_SUBTITLE_AB_TRANSLATE_1_SPECS_ORION_INTRO_SCREEN() {
    return this._translate('ASA_GET_STARTED_ASSISTANT_INTRO_SUBTITLE|abTranslate_1|specs.orion.introScreen', EMPTY_OBJECT);
  }
  ASA_GET_STARTED_ASSISTANT_INTRO_SUBTITLE_AB_TRANSLATE_2_SPECS_ORION_INTRO_SCREEN() {
    return this._translate('ASA_GET_STARTED_ASSISTANT_INTRO_SUBTITLE|abTranslate_2|specs.orion.introScreen', EMPTY_OBJECT);
  }
  ASA_GET_STARTED_ASSISTANT_INTRO_LIST_TITLE_AB_TRANSLATE_1_SPECS_ORION_INTRO_SCREEN() {
    return this._translate('ASA_GET_STARTED_ASSISTANT_INTRO_LIST_TITLE|abTranslate_1|specs.orion.introScreen', EMPTY_OBJECT);
  }
  ASA_GET_STARTED_ASSISTANT_INTRO_LIST_TITLE_AB_TRANSLATE_2_SPECS_ORION_INTRO_SCREEN() {
    return this._translate('ASA_GET_STARTED_ASSISTANT_INTRO_LIST_TITLE|abTranslate_2|specs.orion.introScreen', EMPTY_OBJECT);
  }
  ASA_GET_STARTED_ASSISTANT_INTRO_LIST_ITEM1_AB_TRANSLATE_1_SPECS_ORION_INTRO_SCREEN() {
    return this._translate('ASA_GET_STARTED_ASSISTANT_INTRO_LIST_ITEM1|abTranslate_1|specs.orion.introScreen', EMPTY_OBJECT);
  }
  ASA_GET_STARTED_ASSISTANT_INTRO_LIST_ITEM1_AB_TRANSLATE_2_SPECS_ORION_INTRO_SCREEN() {
    return this._translate('ASA_GET_STARTED_ASSISTANT_INTRO_LIST_ITEM1|abTranslate_2|specs.orion.introScreen', EMPTY_OBJECT);
  }
  ASA_GET_STARTED_ASSISTANT_INTRO_LIST_ITEM2_AB_TRANSLATE_1_SPECS_ORION_INTRO_SCREEN() {
    return this._translate('ASA_GET_STARTED_ASSISTANT_INTRO_LIST_ITEM2|abTranslate_1|specs.orion.introScreen', EMPTY_OBJECT);
  }
  ASA_GET_STARTED_ASSISTANT_INTRO_LIST_ITEM2_AB_TRANSLATE_2_SPECS_ORION_INTRO_SCREEN() {
    return this._translate('ASA_GET_STARTED_ASSISTANT_INTRO_LIST_ITEM2|abTranslate_2|specs.orion.introScreen', EMPTY_OBJECT);
  }
  ASA_GET_STARTED_ASSISTANT_INTRO_LIST_ITEM3_AB_TRANSLATE_1_SPECS_ORION_INTRO_SCREEN() {
    return this._translate('ASA_GET_STARTED_ASSISTANT_INTRO_LIST_ITEM3|abTranslate_1|specs.orion.introScreen', EMPTY_OBJECT);
  }
  ASA_GET_STARTED_ASSISTANT_INTRO_LIST_ITEM3_AB_TRANSLATE_2_SPECS_ORION_INTRO_SCREEN() {
    return this._translate('ASA_GET_STARTED_ASSISTANT_INTRO_LIST_ITEM3|abTranslate_2|specs.orion.introScreen', EMPTY_OBJECT);
  }
}
//# sourceMappingURL=Messages.js.map